import { render } from "./RegisterBlock.vue?vue&type=template&id=18e66514&scoped=true"
import script from "./RegisterBlock.vue?vue&type=script&lang=js"
export * from "./RegisterBlock.vue?vue&type=script&lang=js"

import "./RegisterBlock.vue?vue&type=style&index=0&id=18e66514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e66514"]])

export default __exports__